import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      login: 'Login',
      logging_in: 'Logging in...',
      email: 'Email',
      password: 'Password',
      submit: 'Submit',
      logout: 'Logout',
      leads: 'Leads',
      projects: 'Projects',
      users: 'Users',
      analytics: 'Analytics',
      admin: 'Admin',
      welcome: '',
      status: 'Status',
      unprocessed: 'Unprocessed',
      at_work: 'At Work',
      assigned: 'Assigned',
      happened: 'Happened',
      invalid: 'Invalid',
      non_call: 'Non Call',
      accept_deal: 'Accept Deal',
      replaced: 'Replaced',
      bonus: 'Bonus',
      search: 'Search'
    }
  },
  ru: {
    translation: {
      login: 'Вход',
      logging_in: 'Вход...',
      email: 'Почта',
      password: 'Пароль',
      submit: 'Принять',
      logout: 'Выйти',
      leads: 'Лиды',
      projects: 'Проекты',
      users: 'Пользователи',
      analytics: 'Аналитика',
      admin: 'Админка',
      welcome: '',
      status: 'Статус',
      unprocessed: 'Необработанный',
      at_work: 'В работе',
      assigned: 'Назначен',
      happened: 'Состоялся',
      invalid: 'Недействительный',
      non_call: 'Не дозвонились',
      accept_deal: 'Сделка',
      replaced: 'Заменен',
      bonus: 'Бонусный',
      search: 'Поиск'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ru',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 